import React from "react";

const FilePreviewModal = ({ file, onClose, onDownload }) => {
  if (!file?.url) return null;

  const fileType =
    file.type?.toLowerCase() ||
    file.url.split(".").pop().split("?")[0].toLowerCase();

  const renderPreview = () => {
    if (fileType.startsWith("image")) {
      return <img src={file.url} alt="preview" style={{ maxWidth: "100%" }} />;
    }
    if (fileType === "document") {
      return (
        <iframe
          src={file.url}
          style={{ width: "100%", height: "80vh" }}
          title="PDF Preview"
        />
      );
    }
    // if (fileType.startsWith("video")) {
    //     return (
    //         <>
    //             <video ref={videoRef} onLoadedMetadata={() => {
    //                 if (videoRef.current) {
    //                     setDuration(videoRef.current.duration);
    //                 }
    //             }}>
    //                 <source type="video/mp4" src="https://empoweredmannewuploads.s3.ap-southeast-2.amazonaws.com/794/mqQXa7o9QU_WhatsApp-Video-2025-08-15-at-3.14.16-PM.mp4" />
    //                 Your browser does not support the video tag.
    //             </video>

    //             {/* Video controls */}
    //             {showControls && (
    //                 <div
    //                     style={{
    //                         position: "absolute",
    //                         bottom: "20px",
    //                         left: "0",
    //                         right: "0",
    //                         padding: "10px 15px",
    //                         backgroundColor: "rgba(0, 0, 0, 0.6)",
    //                         borderBottomLeftRadius: "20px",
    //                         borderBottomRightRadius: "20px",
    //                     }}
    //                 >
    //                     <div
    //                         style={{
    //                             display: "flex",
    //                             alignItems: "center",
    //                             gap: "10px",
    //                             marginBottom: "8px",
    //                         }}
    //                     >
    //                         <button
    //                             onClick={togglePlay}
    //                             style={{
    //                                 background: "none",
    //                                 border: "none",
    //                                 cursor: "pointer",
    //                                 color: "white",
    //                                 padding: "5px",
    //                             }}
    //                         >
    //                             {isPlaying ? (
    //                                 <svg
    //                                     width="20"
    //                                     height="20"
    //                                     viewBox="0 0 24 24"
    //                                     fill="none"
    //                                     stroke="white"
    //                                     strokeWidth="2"
    //                                 >
    //                                     <rect x="6" y="4" width="4" height="16" />
    //                                     <rect x="14" y="4" width="4" height="16" />
    //                                 </svg>
    //                             ) : (
    //                                 <svg
    //                                     width="20"
    //                                     height="20"
    //                                     viewBox="0 0 24 24"
    //                                     fill="none"
    //                                     stroke="white"
    //                                     strokeWidth="2"
    //                                 >
    //                                     <polygon points="5 3 19 12 5 21 5 3" />
    //                                 </svg>
    //                             )}
    //                         </button>

    //                         <button
    //                             onClick={toggleMute}
    //                             style={{
    //                                 background: "none",
    //                                 border: "none",
    //                                 cursor: "pointer",
    //                                 color: "white",
    //                                 padding: "5px",
    //                             }}
    //                         >
    //                             {isMuted ? (
    //                                 <img
    //                                     src="/icons/mute.svg"
    //                                     alt="Unmute"
    //                                     style={{ width: "20px", height: "20px" }}
    //                                 />
    //                             ) : (
    //                                 <img
    //                                     src="/icons/unmute.svg"
    //                                     alt="Mute"
    //                                     style={{ width: "20px", height: "20px" }}
    //                                 />
    //                             )}
    //                         </button>

    //                         <span
    //                             style={{
    //                                 color: "white",
    //                                 fontSize: "12px",
    //                                 minWidth: "40px",
    //                             }}
    //                         >
    //                             {formatTime(currentTime)}
    //                         </span>
    //                         <div
    //                             style={{
    //                                 flex: 1,
    //                                 height: "4px",
    //                                 backgroundColor: "rgba(255,255,255,0.3)",
    //                                 borderRadius: "2px",
    //                                 cursor: "pointer",
    //                             }}
    //                             onClick={handleSeek}
    //                         >
    //                             <div
    //                                 style={{
    //                                     width: `${progress}%`,
    //                                     height: "100%",
    //                                     backgroundColor: "#008CFF",
    //                                     borderRadius: "2px",
    //                                 }}
    //                             />
    //                         </div>
    //                         <span
    //                             style={{
    //                                 color: "white",
    //                                 fontSize: "12px",
    //                                 minWidth: "40px",
    //                             }}
    //                         >
    //                             {formatTime(duration)}
    //                         </span>
    //                     </div>
    //                 </div>
    //             )}
    //         </>
    //     )

    // }
    // if (fileType.startsWith("audio")) {
    //     return <audio controls src={file.url} />;
    // }
    return (
      <p>No inline preview available. Please download to view this file.</p>
    );
  };

  return (
    <div className="modal-overlay">
      <div
        className="modal-content"
        style={{
          height: "500px", // fixed height
          overflowY: "auto", // scroll inside if content is too tall
          padding: "20px",
        }}
      >
        <button
          style={{
            padding: "8px 12px",
            marginRight: "10px",
            marginBottom: "20px",
            background: "#ccc",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          Close
        </button>
        {/* <h3>{file.name || file.url.split("/").pop()}</h3> */}
        {renderPreview()}
        <div style={{ marginTop: "1rem" }}>
          <button
            style={{
              padding: "8px 12px",
              background: "#25D366",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => onDownload(file)}
          >
            ⬇ Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
